import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class reloadDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false
        }
    }
	
	componentDidMount() {
		// グローバルイベントを引っ掛ける。
		window.addEventListener("newContentAvailable", () => {
			this.setState({
				open: true
			});
		});
	}
    handleOK = () =>{
        window.location.reload(true)
    };

    render() {
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    更新のお知らせ
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        最新のコンテンツが配信されています。<br />
						リロードします。
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleOK} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
export default reloadDialog;


// WEBPACK FOOTER //
// ./src/common/components/dialog/reload-dialog.js